var map = {
	"./arg.svg": 2321,
	"./aus.svg": 2322,
	"./bel.svg": 2323,
	"./bra.svg": 2324,
	"./can.svg": 2325,
	"./cmr.svg": 2326,
	"./crc.svg": 2327,
	"./cro.svg": 2328,
	"./den.svg": 2329,
	"./ecu.svg": 2330,
	"./eng.svg": 2331,
	"./esp.svg": 2332,
	"./fra.svg": 2333,
	"./ger.svg": 2334,
	"./gha.svg": 2335,
	"./irn.svg": 2336,
	"./jpn.svg": 2337,
	"./kor.svg": 2338,
	"./ksa.svg": 2339,
	"./mar.svg": 2340,
	"./mex.svg": 2341,
	"./ned.svg": 2342,
	"./pol.svg": 2343,
	"./por.svg": 2344,
	"./qat.svg": 2345,
	"./sen.svg": 2346,
	"./srb.svg": 2347,
	"./sui.svg": 2348,
	"./tun.svg": 2349,
	"./uru.svg": 2350,
	"./usa.svg": 2351,
	"./wal.svg": 2352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;